import { vuexfireMutations, firestoreAction } from "vuexfire";

import { db, functions } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    users: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    toggleUser: async (context, payload) => {
      try {
        await functions.httpsCallable("toggleUser")({ payload });
        let newPayload = {
          id: payload.id,
          data: {
            disable: !payload.disable
          }
        };
        context.dispatch("updateUser", newPayload);
      } catch (error) {
        console.error(error);
      }
      return "User has been updated";
    },
    bindUsers: firestoreAction(context => {
      return context.bindFirestoreRef("users", db.collection("users"));
    })
  },
  getters: {}
};
